import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  max-width: 840px;
  width: 100%;
  align-self: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  height: 100%;
  padding-bottom: 64px;

  & > :first-child {
    margin-bottom: 0 !important;
  }
`;
